function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 256,
  x2: 256,
  y1: 512,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fd3a84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa68d"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m406 362c-20.544 0-39.181 8.309-52.74 21.736l-122.508-82.516c6.566-13.703 10.248-29.039 10.248-45.22s-3.682-31.517-10.248-45.22l122.508-82.516c13.56 13.427 32.196 21.736 52.74 21.736 41.355 0 75-33.645 75-75s-33.645-75-75-75-75 33.645-75 75c0 10.023 1.991 19.585 5.574 28.333l-122.515 82.52c-19.234-21.383-47.101-34.853-78.059-34.853-57.897 0-105 47.103-105 105s47.103 105 105 105c30.958 0 58.825-13.47 78.06-34.853l122.515 82.52c-3.584 8.748-5.575 18.31-5.575 28.333 0 41.355 33.645 75 75 75s75-33.645 75-75-33.645-75-75-75zm0-332c24.813 0 45 20.187 45 45s-20.187 45-45 45-45-20.187-45-45 20.187-45 45-45zm-270 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm270 151c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z",
  fill: "url(#SVGID_1_)"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 512 512",
  height: 512,
  viewBox: "0 0 512 512",
  width: 512,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/share.aa0d6fa3.svg";
export { SvgComponent as ReactComponent };